import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import {
  createNewCannedResponse,
  deleteCannedResponse,
  getCannedResponseCategories,
  getCannedResponsesByCategory,
} from '@api/cannedResponses';
import { ICannedResponse, INewCannedResponsePayload } from '@interfaces/cannedResponses';
import { ICannedResponseCategory } from '@interfaces/lookups';

export const handleGetCannedResponseCategories = createAsyncThunk<
  AxiosResponse<ICannedResponseCategory[]>,
  void
>('getCannedResponseCategories', getCannedResponseCategories);

export const handleGetCannedResponsesByCategory = createAsyncThunk<
  AxiosResponse<ICannedResponse[]>,
  number
>('getCannedResponsesByCategory', getCannedResponsesByCategory);

export const handleCreateNewCannedResponse = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  INewCannedResponsePayload
>('createNewCannedResponse', createNewCannedResponse);

export const handleDeleteCannedResponse = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  number
>('deleteCannedResponse', deleteCannedResponse);
